var exports = {
  "k": "xfd349460--a96c48--container",
};

module.exports = exports;
